module.exports = __webpack_public_path__ + "img/root001.aae69451.png";